export enum FeatureName {
  FastAccess = 'FastAccess',
  SmsNotifications = 'SmsNotifications',
  CA3000 = 'CA3000',
  CA4K = 'CA4K',
  EIQIntelliTicket = 'EIQIntelliTicket',
  EIQViolation = 'EIQViolation',
  CA3000Expirations = 'CA3000Expirations',
  NorthStar = 'NorthStar',
  ConnectEditPin = 'ConnectEditPin',
}

export const featureNameMap: Record<FeatureName, string> = {
  [FeatureName.FastAccess]: 'Fast access',
  [FeatureName.SmsNotifications]: 'SMS notifications',
  [FeatureName.CA3000]: 'CA3000',
  [FeatureName.CA4K]: 'CA4K',
  [FeatureName.EIQIntelliTicket]: 'EIQ-IntelliTicket',
  [FeatureName.CA3000Expirations]: 'CA3000 Expirations',
  [FeatureName.NorthStar]: 'North Star',
  [FeatureName.ConnectEditPin]: 'Allow resident edit PIN in EIQ Connect',
  [FeatureName.EIQViolation]: 'EIQ-Violation',
};
